import styled, { CSSObject } from "styled-components";
import { BLUE, NEAR_WHITE } from "../../config";

export const BoxAlert = styled.div<{ color: string; customStyled?: CSSObject }>`
  background-color: ${({ color }) => color};
  border-radius: 5px;
  padding: 15px;
  display: flex;
  width: auto;
  justify-content: flex-start;
  overflow-x: auto;
  ${({ customStyled }) => customStyled}

  h4 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    margin-top: 10px;
    margin-bottom: 8px;
    letter-spacing: 0.4px;
    color: ${NEAR_WHITE};
  }
  h5 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 13px;
    margin: 0px;
    color: ${NEAR_WHITE};
  }

  a {
    text-decoration: none;
    color: ${BLUE};
    font-weight: bold;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  color: ${NEAR_WHITE};
  justify-content: center;
`;

export const Icon = styled.div`
  width: 40px;
  align-self: center;
  font-size: 25px;
  margin-left: 10px;
  margin-right: 10px;
`;
